import React, { useState, useEffect } from "react";
import "../src/assets/css/Header.css";
import "./styles.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Header from "./components/header";
import Home from "./components/home";
import Product from "./components/product";
import Contacts from "./components/contacts";
import News from "./components/news";
import Project from "./components/project";
import Logo from "./assets/img/logo1.png";
// src/App.js (Mã đã chỉnh sửa)
import Footer from "./components/Footer";
import FloatingContactBubble from "./components/FloatingContactBubble";
import ScrollToTopButton from "./components/ScrollToTopButton";
import ProductDetailPage from "./components/ProductDetailPage";
import ScrollToTop from "./components/ScrollToTop";
import ProjectDetail from "./components/project/ProjectDetailPage";
import NewsDetail from "./components/news/Components/newsDetail";
import Login from "./components/login";
import Register from "./components/register";
import HomeLayout from "./HomeLayout";
import AdminLogin from "./Admin/AdminLogin";
import AdminDashboard from "./Admin/AdminDashboard";
import ForgotPassword from "./Admin/ForgotPassword";
import ForgotPasswordHome from "./components/login/Components/ForgotPassword";
import ComingSoon from "./ComingSoon";
import Sitemap from "./assets/js/DynamicSitemap";
function App() {
  const [headerHeight, setHeaderHeight] = useState(0);
  // Component bảo vệ Route (Chỉ cho Admin vào)
  const AdminRoute = ({ children }) => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    // Kiểm tra xem có user không và role có phải admin không
    if (!user || user.role !== "admin") {
      return <Navigate to="/admin/login" />;
    }
    return children;
  };
  const [user, setUser] = useState(null);

  // Hàm này dùng để Header và Login cùng dùng chung
  const refreshUser = () => {
    const savedUser = localStorage.getItem("user");
    setUser(savedUser ? JSON.parse(savedUser) : null);
  };

  useEffect(() => {
    refreshUser();
  }, []);
  return (
    <Router>
      <ScrollToTop />
      <div className="">
        <Routes>
          <Route
            path="/"
            element={
              <HomeLayout
                setHeaderHeight={setHeaderHeight}
                headerHeight={headerHeight}
                user={user}
                refreshUser={refreshUser}
              />
            }
          >
            {/* Đặt nó ở đây, nó sẽ canh chừng mỗi khi bạn đổi trang */}
            {/* Header nằm ngoài Routes nên sẽ luôn hiển thị */}
            {/* Định nghĩa các tuyến đường (Routes) */}
            {/* Trang chủ (ví dụ: Trang chủ sẽ là trang Sản phẩm hoặc Giới thiệu) */}
            <Route path="/" element={<Home headerHeight={headerHeight} />} />
            {/* Các trang menu */}
            <Route path="/" element={<Home headerHeight={headerHeight} />} />
            <Route
              path="/san-pham"
              element={<Product headerHeight={headerHeight} />}
            />
            <Route
              path="/du-an"
              element={<Project headerHeight={headerHeight} />}
            />
            <Route
              path="/tin-tuc"
              element={<News headerHeight={headerHeight} />}
            />
            <Route
              path="/lien-he"
              element={<Contacts headerHeight={headerHeight} />}
            />
            <Route
              path="/san-pham/:slug"
              element={<ProductDetailPage headerHeight={headerHeight} />}
            />
           

// Trong phần Routes của bạn

            <Route
              path="/du-an/:slug"
              element={<ProjectDetail headerHeight={headerHeight} />}
            />
            <Route
              path="/tin-tuc/:slug"
              element={<NewsDetail headerHeight={headerHeight} />}
            />
            <Route
              path="/dang-nhap"
              element={<Login onLoginSuccess={refreshUser} />}
            />
            <Route path="/dang-ky" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPasswordHome />} />
            <Route path="/ve-chung-toi" element={<ComingSoon />} />
             <Route path="/dich-vu" element={<ComingSoon />} />
               <Route path="/chinh-sach-bao-mat" element={<ComingSoon />} />
                <Route path="/dieu-khoan" element={<ComingSoon />} />
                <Route path="/faqs" element={<ComingSoon />} />
          </Route>
          <Route path="/sitemap-auto" element={<Sitemap />} />
          <Route
            path="/admin"
            element={<Navigate to="/admin/login" replace />}
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;